// Detalle corto de un gasto: qué es y de qué período, en una línea, como en
// una liquidación ("Consumo de agua · período 08/08–07/09/2026"). Es lo que se
// ve en la tabla de Gastos, el informe, el estado de cuenta y el PDF del
// cierre. La IA lo arma al leer la factura (description_short, hasta 100
// caracteres) y el admin lo puede corregir; la descripción completa queda en
// el gasto.

export const MAX_DETALLE_CORTO = 100;

const espacios = (t) => String(t ?? "").replace(/\s+/g, " ").trim();

/** Recorta en la última palabra entera que entra, con "…" si hubo que cortar. */
export function recortarDetalle(texto, max = MAX_DETALLE_CORTO) {
  const t = espacios(texto);
  if (t.length <= max) return t;
  const corte = t.slice(0, max - 1);
  const ultimoEspacio = corte.lastIndexOf(" ");
  const base = ultimoEspacio > max / 2 ? corte.slice(0, ultimoEspacio) : corte;
  return `${base.replace(/[\s.,;:\-–—]+$/, "")}…`;
}

// Fin de oración: punto (o ! ?) + espacio + mayúscula. "100.000" y "2,2 kW." al
// final no cortan; la primera oración tiene que decir algo (15+ caracteres).
const FIN_DE_ORACION = /[.!?]\s+(?=[A-ZÁÉÍÓÚÑ¿¡])/g;
const MIN_ORACION = 15;

/** Primera oración de un texto (sin el punto final). */
export function primeraOracion(texto) {
  const t = espacios(texto);
  FIN_DE_ORACION.lastIndex = 0;
  let m;
  while ((m = FIN_DE_ORACION.exec(t))) {
    if (m.index >= MIN_ORACION) return t.slice(0, m.index).trim();
  }
  return t.replace(/[.\s]+$/, "");
}

/**
 * Detalle corto para mostrar: el guardado (shortDescription) o, en gastos sin
 * él, la primera oración de la descripción, siempre <= 100 caracteres.
 */
export function detalleCorto(gasto) {
  return espacios(gasto?.shortDescription) || recortarDetalle(primeraOracion(gasto?.description));
}

/** Valor a guardar en shortDescription (null si queda vacío). */
export function detalleCortoParaGuardar(texto) {
  const t = recortarDetalle(texto);
  return t || null;
}
